import SpinnerStyle from "./SpinnerStyle"

export default function Spinner({ spinning }) {
  return (
    spinning &&
    <SpinnerStyle id="spinner" />
  );
}
